import { render, staticRenderFns } from "./LtoDetails.vue?vue&type=template&id=08783ae0"
import script from "./LtoDetails.vue?vue&type=script&lang=js"
export * from "./LtoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports